import {Component, OnDestroy, OnInit} from "@angular/core";
import {PreguntaModelDTO} from "@Models";
import {Subscription} from "rxjs";
import {TiposPreguntasService} from "../../tipos-preguntas.service";
import {ModalService, NotificacionServiceEmisor} from "@shared/services";
import {debounceTime, filter, mergeMap, tap} from "rxjs/operators";
import {
    EditorCondicionesComponent
} from "../../../../encuestas-detalle/editor-condiciones/editor-condiciones.component";
import {CommandAsync, ICommand} from "@nahuelmorata/ngx-command";
import {PreguntaDTO} from "@DTOS";
import {obtenerIdPreguntaTipo, PreguntasTipoEnum} from "@shared/enums";
import {FormBuilder, Validators} from "@angular/forms";
import {TipoPreguntaComponent} from "../tipo-pregunta/tipo-pregunta.component";


@Component({
    selector: "app-tipo-pregunta-matriz-range",
    templateUrl: "./tipo-pregunta-matriz-range.component.html",
    styleUrls: ["./tipo-pregunta-matriz-range.component.scss"]
})
export class TipoPreguntaMatrizRangeComponent extends TipoPreguntaComponent implements OnInit, OnDestroy {
    public pregunta: PreguntaModelDTO;
    public subPreguntas: PreguntaModelDTO[] = [];

    public colores = {};
    public textoPregunta = "";
    public formGroupRangoOpciones = this.formBuilder.nonNullable.group({
        desde: [0, Validators.required],
        hasta: [1, Validators.required],
        opciones: [2, Validators.required]
    });

    public agregarPreguntaCmd: ICommand = new CommandAsync(() => this.agregarSubpregunta());
    public borrarPreguntaCmd: ICommand = new CommandAsync((pregunta: PreguntaModelDTO) =>
        this.borrarSubpregunta(pregunta));

    private subsPreguntas = new Subscription();

    constructor(private tiposPreguntasService: TiposPreguntasService, private modalService: ModalService,
        private notificacionService: NotificacionServiceEmisor, private formBuilder: FormBuilder) {
        super();
    }

    ngOnInit() {
        this.pregunta = this.tiposPreguntasService.preguntaModel;
        this.colores = this.tiposPreguntasService.colores;

        this.cargarModelsPregunta();
    }

    ngOnDestroy() {
        this.subsPreguntas.unsubscribe();
    }

    public obtenerId(tipoPregunta: PreguntasTipoEnum) {
        return obtenerIdPreguntaTipo(tipoPregunta);
    }

    public abrirEditorCondiciones(pregunta: PreguntaModelDTO) {
        const modalRef = this.modalService.open(
            EditorCondicionesComponent, { size: "lg", centered: true, windowClass: "modal-condiciones" }
        );
        const instancia: EditorCondicionesComponent = modalRef.componentInstance;
        instancia.encuesta = this.tiposPreguntasService.encuesta;
        instancia.pregunta = pregunta;
    }

    public clickBorrarPregunta(pregunta: PreguntaModelDTO) {
        if (this.borrarPreguntaCmd.puedeEjecutarse) {
            this.borrarPreguntaCmd.ejecutar(pregunta);
        }
    }

    private async agregarSubpregunta() {
        let subPreguntaDTO = new PreguntaDTO({
            text: this.textoPregunta,
            type: obtenerIdPreguntaTipo(PreguntasTipoEnum.SINGLE_CHOICE)
        });

        this.textoPregunta = "";
        subPreguntaDTO = await this.tiposPreguntasService.agregarSubpreguntaPregunta(
            this.pregunta.Entidad, subPreguntaDTO
        );
        const model = new PreguntaModelDTO(subPreguntaDTO);
        this.subsPreguntas.add(
            model.changed$.pipe(
                filter(Boolean),
                debounceTime(200),
                mergeMap(() => this.tiposPreguntasService.guardarSubpreguntaPregunta(subPreguntaDTO)),
                tap(() => this.notificacionService.notificarExito("Subpregunta modificada correctamente."))
            ).subscribe()
        );
        this.subPreguntas.push(model);
        this.notificacionService.notificarExito("Subpregunta agregada correctamente.");
    }

    private async borrarSubpregunta(subpregunta: PreguntaModelDTO) {
        const subpreguntaDTO = subpregunta.Entidad;
        subpreguntaDTO.padre = null;
        await this.tiposPreguntasService.guardarPregunta(subpreguntaDTO);
        await this.tiposPreguntasService.borrarSubpreguntaPregunta(this.pregunta.Entidad, subpreguntaDTO);
        this.subsPreguntas.unsubscribe();
        this.subsPreguntas = new Subscription();
        this.cargarModelsPregunta();
        this.notificacionService.notificarExito("Subpregunta eliminada correctamente.");
    }

    private cargarModelsPregunta() {
        this.subPreguntas = this.pregunta.Preguntas?.map(subPregunta => {
            const model = new PreguntaModelDTO(subPregunta);
            this.subsPreguntas.add(
                model.changed$.pipe(
                    filter(Boolean),
                    debounceTime(200),
                    mergeMap(() => this.tiposPreguntasService.guardarSubpreguntaPregunta(subPregunta)),
                    tap(() => this.notificacionService.notificarExito("Subpregunta modificada correctamente."))
                ).subscribe()
            );
            return model;
        }) ?? [];
    }
}
